/**
 * Safe UUID generator that works in both browser and SSR environments
 * Uses the uuid library in browser, falls back to timestamp-based IDs during SSR
 */
import { v4 as uuidv4 } from 'uuid';

const safeUuidv4 = () => {
  // Check if we're in a browser environment with crypto support
  if (typeof window !== 'undefined' && typeof crypto !== 'undefined' && crypto.getRandomValues) {
    return uuidv4();
  }

  // Fallback for SSR - using timestamp + random for uniqueness
  // This should never be used in production as these functions only run client-side
  return `temp-${Date.now()}-${Math.random().toString(36).substring(2, 15)}`;
};

export default safeUuidv4;
